// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))